import { ReactNode, createContext, useMemo } from "react";
import merge from "lodash/merge";

import { types, constants } from "./definitions";

export const WiseOwlContext = createContext<types.WiseOwlContextProps>(
  constants.defaultWiseOwlContext
);

interface WiseOwlProviderProps {
  children: ReactNode;
  context?: Partial<types.WiseOwlContextProps>;
}

export const WiseOwlProvider = ({
  context,
  children,
}: WiseOwlProviderProps) => {
  // init / update Wise Owl Context
  // TODO: we could implement some more complex dependency checking using
  // isEqual. This felt overkill for now but something to keep in mind later
  const wiseOwlContext = useMemo(() => {
    return merge(constants.defaultWiseOwlContext, context);
  }, [context]);

  return (
    <WiseOwlContext.Provider value={wiseOwlContext}>
      {children}
    </WiseOwlContext.Provider>
  );
};
